import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, SecurityContext } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ResponseData } from 'src/app/Model/Base/Response';
import { EthicsComplianceAnswerModel } from 'src/app/Model/EthicsComplianceAnswer.model';
import { RequestModel } from 'src/app/Model/Request.model';
import { DocumentService } from 'src/app/Services/document/Documentservice';
import { EthicsComplianceService } from 'src/app/Services/EthicsCompliance/ethics-compliance.service';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { RequestService } from 'src/app/Services/request/request.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-agency-access-letter',
  templateUrl: './agency-access-letter.component.html',
  styleUrls: ['./agency-access-letter.component.css']
})
export class AgencyAccessLetterComponent implements OnInit, AfterViewInit {

  @Input() request: RequestModel;
  @Output() newRequestEvent = new EventEmitter<number>();
  public isMobile: boolean = false;
  public buttonBool: boolean = false;
  public Url;
  public requestcode: string;
  public lstAnswers: EthicsComplianceAnswerModel[]
  public ethicsComplianceService : EthicsComplianceService
  public labelAccessLetter: string 

  constructor(
    breakpointObserver: BreakpointObserver,
    ethicsComplianceService: EthicsComplianceService,
    private readonly Service: DocumentService,
    protected sanitizer: DomSanitizer,
    private readonly requestService: RequestService,
    private readonly translate: TranslateService,
    private readonly spinner: NgxSpinnerService,
    private readonly lsService : SessionStorageService
  ) {

    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      this.isMobile = result.matches;
    });

    this.ethicsComplianceService = ethicsComplianceService

    
  }

  ngOnChanges() {
    this.ngOnInit()
  }

  ngOnInit(): void {
    if(this.labelAccessLetter == 'False'){
      let evtModel = new EvtModel()
      evtModel.value = 'False'
      this.SetCheck(evtModel);
    }

    this.request.Id = parseInt(this.lsService.getLSItem("IdRequest"))
    this.getAnswers(this.request)

  }

  ngAfterViewInit(){
    this.getUrlTyC();
  }

  public async getUrlTyC(){
    let textoHtml: string
    if(!Number.isNaN(this.request.Id)){
      await this.Service.GetAccessLetterPrint(this.request).then(async (res) => {
        textoHtml = res;
        let encodedUrl = encodeURIComponent(textoHtml)
        this.Url =  `https://docs.google.com/gview?url=${encodedUrl}&embedded=true`
        
        let SafeUrl = this.sanitizer.sanitize(SecurityContext.URL, this.Url);
        this.Url = this.sanitizer.bypassSecurityTrustResourceUrl(SafeUrl);
      });
    }
  }


  async getAnswers(section:RequestModel){
    this.checkAccessLetter.enable()
    let olsIdBillingPeriod = section.IdBillingPeriod;
    section.IdBillingPeriod = 7
    if(!Number.isNaN(section.Id))
      this.lstAnswers = await this.ethicsComplianceService.getAnswersBySection(section)
    this.labelAccessLetter = this.lstAnswers != null ? this.lstAnswers.find(x => x.Question == 1 && x.SubQuestion == null) ? this.lstAnswers.find(x => x.Question == 1 && x.SubQuestion == null).Answer : null  : null

    if(this.lstAnswers != null){
      let rq = await this.requestService.getRequestById(this.lsService.getLSItem("IdRequest"));

      if(rq!=null && rq.RequestStatus!=null){
        this.checkAccessLetter.disable()
      }
    }
    section.IdBillingPeriod = olsIdBillingPeriod
  }

  
  formAccessLetter = new FormGroup({
    checkAccessLetter: new FormControl('',
      [Validators.required]),
  });
  get checkAccessLetter() { return this.formAccessLetter.get('checkAccessLetter'); }


  /**
   * ON SUBMIT **********************************************************
   * ********************************************************************
   */

   async onSubmit(){
    
    this.spinner.show();
    this.lstAnswers = new Array();

    let itemAnswers = new EthicsComplianceAnswerModel();
    itemAnswers.Id = this.lstAnswers != null ? this.lstAnswers.find(x => x.IdQuestionDetail == 60) != null ? this.lstAnswers.find(x => x.IdQuestionDetail == 60).Id : 0   : 0
    itemAnswers.IdQuestionDetail = 60
    itemAnswers.Answer = this.checkAccessLetter.value
    itemAnswers.IdRequest = this.request.Id
    itemAnswers.Section = 7
    itemAnswers.Question = 1
    itemAnswers.SubQuestion = null
    this.lstAnswers.push(itemAnswers) 
    


    let res: ResponseData;
    await this.ethicsComplianceService.post(this.lstAnswers).then(resp => {
      res = resp;
    })

    if (res.head.status.toLowerCase() == 'true') {
      this.newRequestEvent.emit(this.request.Id);
      await Swal.fire({
        icon: 'success',
        text: this.translate.instant('Request.Messages.Success'),
        showConfirmButton: false,
        timer: 2000
      })
      window.location.reload()
    }
    else {
      await Swal.fire({
        title: 'Error!',
        text: this.translate.instant('Request.Messages.ErrorSaving'),
        icon: 'error'
      }
      )
    }

    if(this.request.RequestStatus != null){
      this.checkAccessLetter.disable()
    }

    this.spinner.hide();
  }

  SetCheck(evt){
    if(evt.value == 'False')
    {
      this.buttonBool = false
    }
    else
    {
      this.buttonBool = true
    }
  }
}


export class DataModal {
  public Request: RequestModel;
  public Answers: EthicsComplianceAnswerModel[];
}

export class EvtModel {
  public value: string;
}
